import './App.css';

function App() {
  return (
    <div className="App">
      <div className="coming-soon-container">
        <div className="content">
          <h1 className="logo">news14Hd Tv</h1>
          <h2 className="title">Coming Soon</h2>
          <p className="message">We're working hard to bring you something amazing!</p>
          <p className="submessage">Our website is under construction. Stay tuned for updates.</p>
        </div>
      </div>
    </div>
  );
}

export default App;
